import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=002056e6"
import script from "./Response.vue?vue&type=script&lang=js"
export * from "./Response.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports